<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">4</h2>
<p class="vers"><span>O du</span> meines Lebens
Leben! Immer<br class="calibre1"/>
werd ich mich mühn, rein meinen Leib<br class="calibre1"/>
zu erhalten, wissend, daß auf meinen<br class="calibre1"/>
Gliedern lebendig dein Hauch ist.</p>
<p class="vers">Immer werd ich mich mühn, Unwahres<br class="calibre1"/>
mir fern vom Denken zu halten, wissend:<br class="calibre1"/>
du bist die Wahrheit, die mir im Geiste<br class="calibre1"/>
das Licht der Vernunft entzündet.</p>
<p class="vers">Immer werd ich mich mühn, von meinem<br class="calibre1"/>
Herzen die Übel zu treiben und meine<br class="calibre1"/>
Liebe in Blüte zu halten, wissend: du<br class="calibre1"/>
thronest im Allerheiligsten meines Herzens.</p>
<p class="vers">Und es soll immer mein Streben sein:<br class="calibre1"/>
dich offenbaren in meinem Tun, wissend,<br class="calibre1"/>
daß deine Macht mir Kraft gibt zum Handeln. <a id="page7" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?887b9d18